import createVueApp from '@phoenix/createVueApp';
import StockNotifyModal from '@maison/components/product/StockNotifyModal.vue';

const app = createVueApp({}, true);
app.component('StockNotifyModal', StockNotifyModal);
app.mount('#phoenix-stock-notify-modal');
